export default __webpack_public_path__ + "a411a6ecd99c3c7bbf99501737c1ed0b.svg";